import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { Logger } from '../logger.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';



const log = new Logger('AuthenticationGuard');

@Injectable()
export class AuthenticationGuard {

  constructor(private readonly router: Router,
    private readonly authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    return this.authenticationService.validateLogin(state.url);


  }

}
